import { createSelector } from 'reselect'
import { getViewedOrder } from 'selectors/orderSelectors'
import getOrderLoyaltyTransferExperience from './getOrderLoyaltyTransferExperience'
import determineLoyaltyEligibleTransferOptions from './determineLoyaltyEligibleTransferOptions'

const getLoyaltyEligibleTransferOptions = createSelector(
  (state: App.State) => getViewedOrder(state),
  (state: App.State) => getOrderLoyaltyTransferExperience(state),
  (state: App.State) => state.experience.experienceTransferOptions,
  determineLoyaltyEligibleTransferOptions,
)

export default getLoyaltyEligibleTransferOptions
